module.exports = __webpack_public_path__ + "img/corporativo-pc.0f98affa.png";